import Vue from 'vue'
import uiCommonMutations from '@/store/ui/common/mutations'

const mutations = {
    ...uiCommonMutations,

    setDefaultVolumeAlertForm(state) {
        Vue.set(state, 'form', {})
        Vue.set(state, 'isEdit', false)
        Vue.set(state, 'showForm', false)
    },

    setVolumeAlertForm(state, { form }) {
        Vue.set(state, 'form', form)
    },

    setIsEditVolumeAlert(state, { isEdit }) {
        Vue.set(state, 'isEdit', isEdit)
    },

    setShowVolumeAlertForm(state, { show }) {
        Vue.set(state, 'showForm', show)
    }
}

export default mutations
